import ContexteOrganisation from "./ContexteOrganisation";
import FicheProcessus from "./FicheProcessus";
import InformationsDocumentees from "./InformationsDocumentees";
import MaintenancePreventive from "./MaintenancePreventive";
import MatriceInteractions from "./MatriceInteractions";
import PartiesInteressees from "./PartiesInteressees";
import PlanActionsObjectifs from "./PlanActionsObjectifs";
import PlanCommunication from "./PlanCommunication";
import ProcedureReunion from "./ProcedureReunion";
import RessourcesSurveillees from "./RessourcesSurveillees";
import SuiviTraitement from "./SuiviTraitement";
import TableauBordQualite from "./TableauBordQualite";
import VeilleReglementaire from "./VeilleReglementaire";

const TOOL_DEFINITIONS = [
  { clause: "§4.1", component: ContexteOrganisation, key: "contexte", label: "Contexte de l'organisation", number: 1 },
  { clause: "§4.2", component: PartiesInteressees, key: "parties", label: "Parties intéressées", number: 2 },
  { clause: "§4.4", component: FicheProcessus, key: "fiche", label: "Fiche processus", number: 3 },
  { component: MatriceInteractions, key: "interactions", label: "Matrice interactions", number: 4 },
  { clause: "§6.2", component: PlanActionsObjectifs, key: "objectifs", label: "Plan d'action objectifs", number: 5 },
  { clause: "§7.1.3", component: MaintenancePreventive, key: "maintenance", label: "Maintenance préventive", number: 6 },
  { component: RessourcesSurveillees, key: "ressources", label: "Ressources surveillées", number: 7 },
  { clause: "§7.5", component: ProcedureReunion, key: "reunion", label: "Procédure réunion", number: 8 },
  { clause: "§7.4", component: PlanCommunication, key: "communication", label: "Plan de communication", number: 9 },
  { clause: "§7.5", component: InformationsDocumentees, key: "documents", label: "Informations documentées", number: 10 },
  { clause: "§6.1", component: VeilleReglementaire, key: "veille", label: "Veille réglementaire", number: 11 },
  { clause: "§9.1", component: TableauBordQualite, key: "tableau-bord", label: "Tableau de bord qualité", number: 12 },
  { clause: "§10.2", component: SuiviTraitement, key: "suivi", label: "Suivi de traitement", number: 13 },
];

export default TOOL_DEFINITIONS;
